import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import Popup from "@my-dld/components/Popup/Popup";
import { getAppServices } from "@10x/coreapp";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { navigate } from "@my-dld/utils/StoreUtils";
import { JQModal } from "@my-dld/components/Popup/Utils";
import { propertiesId } from "./PropertyIDs";

interface Props {
	onHomePressed: Function;
	refNumber?: string;
}

interface State {
	properties?: AssetCard[];
}

class FreeholdPropertiesPopUp extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {} as State;
	}

	private populateFreeHoldProperties = (assets: AssetCard[]): AssetCard[] => {
		let freeHoldProps: AssetCard[] = [];
		// console.log("NEW ASSETS =============== ", assets);
		assets?.map((u) => {
			if (propertiesId.includes(u.tabuPropertyId)) {
				freeHoldProps.push(u);
			}
		});

		return freeHoldProps;
	};

	private onPropertySelect = ( property: AssetCard ) => {
		JQModal( "msgFreeholdProperty" ).hide();
		navigate( `/mydld/property/${ property.propertyTypeId }/${ property.propertyId }`, undefined, {
			property: property,
		} );
	};

	componentDidMount() {
		const store = getAppServices().storeService.getStore();
		// console.log("store.getState().UserData.properties" , store.getState().UserData.properties);
		if ( store.getState().UserData.properties ) {
			this.setState({properties: this.populateFreeHoldProperties(store.getState().UserData.properties!)});
		}
	}
	render() {
		return <Popup
			showCloseButton={ false } clickOutsideToDismiss={ false }
			modalSubContainer={ "modal-dialog modal-dialog-centered" }
			id={ "msgFreeholdProperty" } title={ Strings.confirmation }
			showIcon={ false } modalBodyContainer={""}>
			<div id="msgFreeholdProperty">
				<div className="modal-header">
					<h5 id="kycUpdateRequiredKYCLabel" className="modal-title">Information</h5>
					<button type="button" className="close modal-close-svg-icon" data-bs-dismiss="modal" aria-label="Close">
						<span className="close-svg-icon"></span>
						<span className="sr-only">Close</span>
					</button>
				</div>
				<div className="modal-body p-3">
					<div className="text-center mb-3">
						<i className="fas fa-info-circle fa-2x"></i>
					</div>
					<div>
						<div className="mb-2">{Strings.dear_customer}</div>
						{Strings.dear_customer_message} <a
						href="mailto:myland@dubailand.gov.ae" className="underline link-color">myland@dubailand.gov.ae</a></div>

					<div className="fh-convertible-property">
						<table className="table">
							<thead>
							<tr>
								<th>{Strings.plot_no}</th>
								<th>{Strings.area_name}</th>
								<th></th>
							</tr>
							</thead>
							<tbody>
							{ this.state.properties?.map( ( value, index ) => {
								return <tr>
									<td data-label={ Strings.municipality_no }>{ value.municipalityNo }</td>
									<td data-label={ Strings.area_name }>{ value.area.englishName }</td>
									<td data-label="Action" className="text-end">
										<button
											type="button" className="btn underline p-0 font-size16"
											onClick={ () => this.onPropertySelect( value ) }>
											{ Strings.view_property }
										</button>
									</td>
								</tr>;
							} ) }
							</tbody>
						</table>
					</div>
				</div>
				<div className="modal-footer d-flex align-items-center justify-content-center py-2">
					<button className="btn btn-grey m-0" data-bs-dismiss="modal">Close</button>
				</div>
			</div>
		</Popup>;
	}
}

function PropertiesTableItem( props: { data: AssetCard } ) {
	const { data } = props;
	return ;
}

export default FreeholdPropertiesPopUp;
